var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 544 458.6",
    style: {
      enableBackground: "new 0 0 544 458.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADE0D9;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#004C96;}\n\t.st3{fill:#F2F2F2;}\n\t.st4{opacity:0.7;enable-background:new    ;}\n\t.st5{fill:#50B89D;}\n\t.st6{opacity:0.44;enable-background:new    ;}\n\t.st7{fill:#AB8DE5;}\n\t.st8{fill:#73E5E2;}\n\t.st9{fill:#176385;}\n\t.st10{fill:#07274A;}\n\t.st11{fill:#00AF9A;}\n\t.st12{fill:#1F161E;}\n\t.st13{fill:#F8CDBA;}\n\t.st14{fill:#FA9E9F;}\n\t.st15{fill:#969696;}\n\t.st16{fill:#D8D8D8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(48.367 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 229.3,
    cy: 229.3,
    r: 229.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.3,
    y: 129.3,
    className: "st1",
    width: 140.6,
    height: 217.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 261.7,
    className: "st2",
    width: 144.2,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 276,
    className: "st2",
    width: 144.2,
    height: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 290.2,
    className: "st2",
    width: 144.2,
    height: 1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 304.4,
    className: "st2",
    width: 144.2,
    height: 1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 334.6,
    cy: 192.8,
    r: 36.8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1924",
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.3,
    y: 206.7,
    className: "st5",
    width: 58.1,
    height: 54
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3853"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.9,232.7l10.6,5.1v-1.7l-8.9-4.2l8.9-4.2V226l-10.6,5.1V232.7z M413.4,240.4h1.7l5.7-17h-1.7L413.4,240.4z  M427.6,237.8l10.6-5.1v-1.6l-10.6-5.1v1.7l8.9,4.2l-8.9,4.2L427.6,237.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1925"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.7,229.2H20.9V21.7h314.8V229.2z M21.9,228.2h312.8V22.7H21.9V228.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 32.7,
    className: "st1",
    width: 313.8,
    height: 1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1926"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139,146.4H43.7V51.1H139V146.4z M44.7,145.4H138V52.1H44.7V145.4z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 59.4,
    className: "st1",
    width: 144.2,
    height: 1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 73.7,
    className: "st1",
    width: 144.2,
    height: 1
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 87.9,
    className: "st1",
    width: 144.2,
    height: 1
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "L\\xEDnea_9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 102.1,
    className: "st1",
    width: 144.2,
    height: 1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3471",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.4,76.5L65.7,121h51.4L91.4,76.5z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 28.2,
    cy: 27.9,
    r: 2.7
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 37.4,
    cy: 27.9,
    r: 2.7
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 46.6,
    cy: 27.9,
    r: 2.7
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3472"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.6,190.6l8.9-7.9h-9.1L159.6,190.6z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1927"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.8,153.4h38.6c8.4,0,15.1,6.8,15.1,15.1l0,0c0,8.4-6.8,15.1-15.1,15.1h-38.6c-8.4,0-15.1-6.8-15.1-15.1 l0,0C150.7,160.1,157.5,153.4,165.8,153.4z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 175.9,
    cy: 168.5,
    r: 2.7
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185.1,
    cy: 168.5,
    r: 2.7
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 194.3,
    cy: 168.5,
    r: 2.7
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3473"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M441.4,101.6l-8.9-7.9h9.1L441.4,101.6z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1928"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M396.6,64.4h38.6c8.4,0,15.1,6.8,15.1,15.1l0,0c0,8.4-6.8,15.1-15.1,15.1h-38.6c-8.4,0-15.1-6.8-15.1-15.1 l0,0C381.5,71.1,388.3,64.4,396.6,64.4z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 425.1,
    cy: 79.5,
    r: 2.7
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 415.9,
    cy: 79.5,
    r: 2.7
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 406.7,
    cy: 79.5,
    r: 2.7
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 436.6,
    cy: 25.2,
    r: 2.7
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 442.3,
    cy: 36.2,
    r: 2.7
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 380.9,
    cy: 144.5,
    r: 4.2
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_15"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 405.2,
    cy: 158.7,
    r: 4.2
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3474"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.3,352.2L399.3,352.2c-0.1,0-0.2-0.1-0.2-0.2c0.1-25.6,26.9-64.5,33.4-71.1c0.1-0.1,0.2-0.1,0.3,0 s0.1,0.2,0,0.3c-6.6,6.6-33.2,45.2-33.3,70.8C399.5,352.1,399.4,352.2,399.3,352.2z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3475"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.7,340.4c-0.1,0-0.1,0-0.1-0.1c-1.4-1.5-2.8-4.4-4-7.9c-1-3.2-1.6-6.1-1.4-7.3c0-0.1,0.1-0.2,0.2-0.2 c0.1,0,0.2,0.1,0.2,0.2c-0.4,2.5,2.4,11.8,5.3,14.9c0.1,0.1,0.1,0.2,0,0.3C400.8,340.4,400.8,340.4,400.7,340.4z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Man",
    transform: "translate(450.493 60.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3476"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M9.6,129.6c-1.5,7.2-12.4,96-8.8,117.2s61.7,65.7,64.2,66.4c3-2.2,7.3-9.3,7.3-9.3s-42.6-49.4-43.4-51.4 s9.3-116.4,9.3-116.4L9.6,129.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3477"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M79,145.8L35.5,323.2H20.8l14.8-185.1L79,145.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3478"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M48.1,44.2c6,0,37.3,1,43,12s0.3,62-3.2,63.9c-1.9,1.1-2.4,0-3,2.2c-0.6,2.2-5.9,23.4-5.9,23.4 c-3.4,0.1-53.2-7.4-69.4-16.2c0.1-2.4,0.9-8.8,0.9-9.3c-2.1,0.9-4.7,1.1-5.5,0c-6.3-9.6,3.1-59.4,9.8-69.4 C17.7,46.6,38.5,44.3,48.1,44.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3479"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M68.7,121.6c1.5,0,14.1,8.9,13.1,13.3c0.9-3.5,3.7-14.4,3.7-14.4C84.2,120.7,69.8,121.6,68.7,121.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3480"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M55.8,50c0,1.9-15.3,1.9-15.3,0V30.5h15.3V50z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3481"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M47.1,35.1c1.2,0,8.8,3.3,8.8,5.2v-9.8C53.9,30.5,47.1,35.1,47.1,35.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 45,
    cy: 21.7,
    r: 14.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3482"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40,0c-7.6,0-12.4,4.8-12.4,10.9c0,5.1,1.2,8,2.7,8.7c0.9-4.9,2.9-7.2,4.6-8.2c1.3,1,3.5,3.4,6.4,4.1 c2.9,0.7,10.6,0.6,16.8,5.1c2-1.8,4-4.2,4-7s-1.2-6.4-8.6-8.4C48.7,3.8,48,0,40,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 31.1,
    cy: 24.7,
    rx: 2.6,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 47.5,
    cy: 24.7,
    rx: 2.6,
    ry: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3483"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M37.1,27.2c-0.1,0-0.1,0-0.2,0c-0.8-0.3-1.2-0.8-1.4-1.5c-0.4-1.4,0.8-3,1.4-3.8l0.2-0.2 c0.2-0.2,0.5-0.3,0.7-0.1c0.2,0.2,0.3,0.5,0.1,0.7l-0.2,0.2c-0.4,0.6-1.5,2-1.2,3c0.1,0.4,0.4,0.6,0.8,0.8 c0.3,0.1,0.4,0.4,0.3,0.7C37.5,27.1,37.3,27.2,37.1,27.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3484"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.4,30.6c-0.2,0-0.4-0.2-0.5-0.4c-0.1-0.3,0.1-0.5,0.4-0.6c1-0.2,1.8-0.8,2.3-1.6c0.2-0.2,0.5-0.3,0.7-0.1 c0.2,0.2,0.3,0.5,0.1,0.7c-0.7,1-1.7,1.8-2.9,2.1C42.5,30.6,42.4,30.6,42.4,30.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_20"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 58.7,
    cy: 23.4,
    r: 3.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3485"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M9.7,121.2c-0.2,0-0.4-0.1-0.5-0.4c-0.1-0.3,0.1-0.5,0.3-0.6c4.7-1.4,23.2-9.8,38-16.6c9.3-4.3,17.5-8,20-9 c-0.3-3.4,0.8-18.8,1-21.3c0-0.3,0.3-0.5,0.5-0.5c0.3,0,0.5,0.3,0.5,0.5c-0.3,3.9-1.3,19.5-0.9,21.5l0.1,0.4l-0.4,0.1 c-2,0.7-10.5,4.6-20.3,9.1c-14.9,6.8-33.4,15.2-38.1,16.7C9.8,121.2,9.7,121.2,9.7,121.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3486"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M14,96.8c-0.2,0-0.4-0.1-0.5-0.3c-2.6-8.1,1.3-25.5,2.1-28.3c0.1-0.3,0.3-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6c-0.8,2.8-4.6,19.9-2.1,27.7c0.1,0.3-0.1,0.5-0.3,0.6C14.1,96.8,14.1,96.8,14,96.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3487"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M70.3,122.4c-24.1,0-40.8-7.5-42.8-8.9c-0.2-0.2-0.3-0.5-0.1-0.7s0.5-0.3,0.7-0.1 c2.3,1.6,24.9,11.6,56.2,7.9c0.3,0,0.5,0.2,0.6,0.4c0,0.3-0.2,0.5-0.4,0.6C79.5,122.2,74.7,122.4,70.3,122.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3488"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M25.6,96.3c1.5,0.2-3.4-3.7-6.3-2.2s-6.6,8.2-5.8,9.7c0.4,1,1.5,1.6,2.6,1.2c0.1-0.1,0.3-0.1,0.4-0.2 C17.2,104.3,22.9,95.9,25.6,96.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3489"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M71.8,304.7c0.8,0.6,8,5.5,8.1,8.5s-6.7,13.3-8.1,13.5s-2.3-0.9-2.3-2.9s2.6-5.7,2.2-7.3s-3.7-4.5-5.4-4.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M34.1,323.2c0,1.4,0.8,10.3-0.8,11.1c-1.6,0.8-19.7,1.3-20.5,0.5s-1.3-2.5-0.6-3s7.7-1.9,8.7-2.5 s2.3-4.2,1.8-6"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Woman",
    transform: "translate(-0.002 127.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 190.4,
    className: "st10",
    width: 114.7,
    height: 58.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3491"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.7,163.1c0.5,3,9,70.8,10.3,71.9s15.9,3.6,17.2,1.7c0.2-3,0.6-50.3,1.4-54.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3492"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23,149c-5.9-2.9,6.4,54.4,38.6,54.4s86.4-49,95.2-49c19.4,0,65.2,38,68.8,38c2.8-2.8,8.3-7.6,8.3-9.5 s-43.9-74.2-76.7-74.2C144.3,108.7,36.2,155.5,23,149z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3493"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M41.1,149.9c6.4-1.5,14.4-5.2,21.5-9.1c-19.3,6.3-35.1,10.4-39.7,8.1c-3.1-1.5-1.1,13.8,6.2,28.6 C27.8,174.7,26,153.4,41.1,149.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3494"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M55.3,49.5c5.1,0.1,31.5-0.6,38.7,6.3c5.4,5.1,22.1,49.1,24.6,64.5c-11.2,5.7-92.1,44.4-117.1,27.4 c-0.6-13.2,2-65.8,18.4-93.4C25.9,50.3,50.4,49.3,55.3,49.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3495"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M65.6,36.9H50.2v16.6c0,4.2,15.4,4.1,15.4,0L65.6,36.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3496"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M50.2,46.9c0-1.8,5.1-6.5,8.2-6.3c0.1-2-7.2-5-7.2-5l-1.1,2.8L50.2,46.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3497"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M81.7,36.9c0.3-1.6,0.5-3.2,0.5-4.9c0-12.2-9.6-22.2-21.4-22.2S39.6,19.8,39.6,32c0,1.6,0.2,3.3,0.5,4.9 H81.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3498"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M76.1,21.9c-2.6-0.4-5.2-2.5-7-3.8c-10.4,7.6-17,7.7-17.8,7.7s-3.6,4.2-5,4.7l-0.1-0.1 c1.6,8.8,10,14.7,18.8,13.1c8.8-1.6,14.7-10,13.1-18.8c-0.2-1-0.4-1.9-0.8-2.8C76.9,22,76.5,22,76.1,21.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 49.3,
    cy: 6.3,
    r: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3499"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.2,31.3C52.1,31.3,52.1,31.3,52.2,31.3c-1.7-0.1-3-1.4-3-3c0-0.8,0.3-1.6,0.8-2.3c0.6-0.6,1.4-1,2.2-1 c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5c-0.6,0-1.1,0.3-1.5,0.7c-0.4,0.4-0.6,1-0.6,1.5c0,1.1,1,2,2.1,2.1 c0.3,0,0.5,0.2,0.5,0.5C52.6,31.1,52.4,31.3,52.2,31.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3500"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.3,31.1c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7c0.7-0.5,1.1-1,1.2-1.5c0.1-0.8-0.5-1.5-1-2.2 c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.2-0.1-0.5,0.1-0.7c0.2-0.2,0.5-0.1,0.7,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.6,0.7,1.4,1.7,1.2,2.9 c-0.1,0.8-0.7,1.5-1.6,2.2C72.5,31.1,72.4,31.1,72.3,31.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3501"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M65.9,35.6c0,0-0.1,0-0.1,0c-1.9-0.5-2.4-2.5-2.4-3.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5 c0,0.1,0,2.2,1.6,2.6c0.3,0.1,0.4,0.4,0.3,0.6C66.3,35.5,66.1,35.6,65.9,35.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 58.8,
    cy: 30.9,
    rx: 2.4,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 76.9,
    cy: 30.9,
    rx: 2.4,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3502"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.5,95.3l16.5-4.2c1.6,2.7,9.3,29.2,9.3,29.2l-25.5,10.7C94.1,125.9,95.1,103,93.5,95.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3503"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33,104.8c0,0-0.1,0-0.1,0c-0.3-0.1-0.4-0.3-0.3-0.6c1-3.7,2.7-11.1,2.7-13c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5c0,2.1-1.7,9.9-2.7,13.3C33.4,104.7,33.2,104.8,33,104.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3504"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M93.5,95.8c-0.2,0-0.5-0.2-0.5-0.4c-0.6-4.8-2.9-21.2-6.6-30c-0.1-0.3,0-0.5,0.3-0.7c0.3-0.1,0.5,0,0.7,0.3 c3.8,8.9,6.1,25.4,6.7,30.3C94,95.5,93.8,95.8,93.5,95.8C93.5,95.8,93.5,95.8,93.5,95.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3505"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.5,95.3l16.5-4.2c1.6,2.7,9.3,29.2,9.3,29.2l-25.5,10.7C94.1,125.9,95.1,103,93.5,95.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3506"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M226,190.9c0.4,0.6,5.3,6.6,7,6.7s12.3-7.1,11.8-8.6s-7.1-0.5-8.2-1.1c-1.7-1.1-3.1-2.5-4.1-4.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3507"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200.1,235.6c-0.1,0.7-0.8,8.4,0.4,9.7s13.8,3.4,14.5,2s-4.7-5.3-5.2-6.5c-0.5-1.9-0.5-3.9,0-5.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3508"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M180.4,121.9h-55.9l13.3-35.2h55.9L180.4,121.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1930"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 120.5,
    className: "st15",
    width: 55.9,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3509"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M33,104.3c-1.1,4-6.3,21.2-4.2,24.2c2.1,3,55.3-3.8,69.5-8.2c3.6-1.2,6.3-4.3,7.9-4.7 c4.3-0.7,8.4,1.9,9.6,6.1c-5.7,2.8-87.7,44.6-114.3,26c-5-3.6,3.8-47.5,4.2-49.7C10.2,98.5,33,104.3,33,104.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3510"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.9,122.1c-0.2,0-0.4-0.1-0.5-0.4c-1.1-3.9-5-6.4-9-5.7c-0.5,0.1-1.4,0.8-2.4,1.5 c-1.5,1.1-3.3,2.5-5.5,3.2c-1.2,0.4-2.6,0.7-4.2,1.1c-0.3,0.1-0.5-0.1-0.6-0.4c-0.1-0.3,0.1-0.5,0.4-0.6c1.6-0.4,3-0.8,4.1-1.1 c2-0.7,3.8-2,5.2-3c1.1-0.8,2-1.5,2.8-1.7c4.6-0.8,8.9,2,10.2,6.4c0.1,0.3-0.1,0.5-0.3,0.6C116,122.1,115.9,122.1,115.9,122.1z"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2198",
    transform: "translate(356.542 275.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4,28c12,2.3,9.8,73.7-13.1,69.3C20.6,93.2,40.9,25.2,55.4,28z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3415"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2.9,36.8c9.5-5.4,49.4,44.8,31.1,55.1C16.8,101.6-8.7,43.3,2.9,36.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M51.4,131.8h-24c-2,0-3.7-1.5-3.9-3.5l-3-27.3c-0.3-2.2,1.3-4.1,3.4-4.4c0.2,0,0.3,0,0.5,0h30 c2.2,0,3.9,1.8,3.9,3.9l0,0c0,0.1,0,0.3,0,0.4l-2.9,27.3C55.2,130.3,53.5,131.8,51.4,131.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3417"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62.2,0.1c9.1,2.6,2.1,57.8-15.3,52.7C30.4,48,51.1-3.1,62.2,0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3418"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M77.2,44c6.3,5.4-19.3,46.9-31.4,36.5C34.4,70.7,69.5,37.4,77.2,44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_3419"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M39.5,5.9c13.6,0,26.1,87.1,0,87.1C14.8,93,22.9,5.9,39.5,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2419"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M17.8,90.7h43.3c2.7,0,4.9,2.2,4.9,4.9v0c0,2.7-2.2,4.9-4.9,4.9H17.8c-2.7,0-4.9-2.2-4.9-4.9v0 C12.9,92.9,15.1,90.7,17.8,90.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login_image.5a3b76cd.svg";
export { ForwardRef as ReactComponent };